import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function NotAloneFeedbackPage() {
  const { t } = useTranslation()

  const allAnswers = getAllAnswers()
  const feeling = allAnswers.feelings?.answer_key || 'Overwhelmed'
  const isOverwhelmed = feeling === 'Overwhelmed' || feeling === 'Stuck'

  return (
    <FeedbackPage
      emoji="💛"
      heading={t(
        isOverwhelmed
          ? 'pages.onboarding.notAloneFeedback.overwhelmed.heading'
          : 'pages.onboarding.notAloneFeedback.general.heading',
      )}
      text={t(
        isOverwhelmed
          ? 'pages.onboarding.notAloneFeedback.overwhelmed.text'
          : 'pages.onboarding.notAloneFeedback.general.text',
      )}
      onSubmit={() => {}}
    />
  )
}
